// @flow
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

export const FaqSection = styled.div`
  margin-top: 80px;
  margin-bottom: 40px;
  background: white;
  padding: 60px;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
  border: 1px solid #f0f0f0;

  .faq-header {
    margin-bottom: 40px;

    h2 {
      font-size: 32px;
      font-weight: 700;
      margin-bottom: 16px;
      color: #1a1a1a;
      padding-left: 0;

      &::before {
        display: none;
      }
    }

    p {
      font-size: 18px;
      color: #666;
      max-width: 800px;
      line-height: 1.5;
    }
  }

  /* Override FaqItem layout inside this section */
  > div:not(.faq-header) {
    max-width: 100%;
    margin: 0;
    padding-left: 0 !important;
    padding-right: 0 !important;
    border-top: 1px solid #f0f0f0;
    padding-top: 24px;
    margin-top: 24px;
    border-bottom: none;

    &:first-of-type {
      border-top: none;
      padding-top: 0;
      margin-top: 0;
    }

    /* Give space to the question */
    > div:first-child {
      min-width: 42%;
      padding-right: 50px;
    }

    > div:last-child {
      min-width: 58%;
      padding-left: 0;
    }

    h2 {
      max-width: 100% !important;
      line-height: 1.4;
      font-size: 20px;
      color: #1a1a1a;
      font-weight: 700;
      display: flex;
      align-items: flex-start;

      &::before {
        content: '?';
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 24px;
        height: 24px;
        background: ${props => props.theme.plus.secondaryL};
        color: white;
        border-radius: 50%;
        font-size: 14px;
        margin-right: 12px;
        flex-shrink: 0;
        margin-top: 2px;
      }
    }
  }

  ${maxMediaQueries.tablet`
    margin-top: 40px;
    margin-bottom: 40px;
    padding: 40px 24px;

    .faq-header {
      h2 {
        font-size: 24px;
      }

      p {
        font-size: 16px;
      }
    }

    > div:not(.faq-header) {
      flex-direction: column;
      padding-top: 30px;
      margin-top: 30px;
      
      > div:first-child, > div:last-child {
        width: 100%;
        min-width: 100%;
        padding-left: 0;
        padding-right: 0;
      }

      > div:first-child {
        margin-bottom: 16px;
      }

      h2 {
        font-size: 18px;
      }
    }
  `};

  .faq-answer {
    line-height: 1.8;
    font-size: 16px;
    color: #444;

    p {
      margin-bottom: 1.2em;
      
      &:last-child {
        margin-bottom: 0;
      }
    }
    
    strong {
      color: #333;
    }
  }
`;
